import { getCanonicalSiteUrl } from "@/lib/utils/get-canonical-site-url"

/**
 * Environment-aware Supabase configuration with STRICT environment isolation.
 *
 * CRITICAL: All Supabase URLs MUST come from environment variables only.
 * DO NOT hardcode project refs or use cached/legacy URLs.
 *
 * For Stage A: All environments use logosos-core-stg (ibhqqqvigscgesyycsid).
 */

// All env vars should point to ibhqqqvigscgesyycsid

export function getSupabaseConfig() {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

  // During build/prerendering OR when env vars are missing, return placeholder config
  // This allows the app to render and show appropriate error messages
  if (!supabaseUrl || !supabaseAnonKey) {
    // Log warning in browser context
    if (typeof window !== "undefined") {
      console.warn(
        "[Supabase Config] Missing required environment variables: NEXT_PUBLIC_SUPABASE_URL or NEXT_PUBLIC_SUPABASE_ANON_KEY. Authentication features will not work.",
      )
    }
    // Return placeholder config that can be detected by consuming code
    return {
      url: "https://placeholder.supabase.co",
      anonKey: "placeholder-key",
      redirectUrl: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
      environment: "unconfigured" as const,
      isPreviewOrStaging: true,
      isConfigured: false,
    }
  }

  const env = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV || "development"
  const siteUrl = getCanonicalSiteUrl()

  const DELETED_PRODUCTION_REF = "azmecxfqmsesqiotkmez"
  if (supabaseUrl.includes(DELETED_PRODUCTION_REF)) {
    const errorMsg = `[Supabase Config] FATAL: Using DELETED production Supabase project (${DELETED_PRODUCTION_REF}). This project no longer exists. Update NEXT_PUBLIC_SUPABASE_URL to use staging project: ibhqqqvigscgesyycsid`
    console.error(errorMsg)
    throw new Error(errorMsg)
  }

  const STAGING_REF = "ibhqqqvigscgesyycsid"
  if (!supabaseUrl.includes(STAGING_REF)) {
    console.warn(
      `[Supabase Config] WARNING: Expected staging project ref '${STAGING_REF}' not found in NEXT_PUBLIC_SUPABASE_URL. Current: ${supabaseUrl}`,
    )
  }

  console.log("[v0][Supabase Config] Configuration:", {
    environment: env,
    supabase_url: supabaseUrl,
    redirect_url: siteUrl,
    vercel_env: process.env.NEXT_PUBLIC_VERCEL_ENV,
  })

  return {
    url: supabaseUrl,
    anonKey: supabaseAnonKey,
    redirectUrl: siteUrl,
    environment: env,
    isPreviewOrStaging: env !== "production",
    isConfigured: true,
  }
}
